/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-native/no-inline-styles */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { createDrawerNavigator } from '@react-navigation/drawer';
import DrawerMenu from '@/navigation/components/DrawerMenu';

import HomeNavigator from '@/navigation/HomeNavigator';
import BusinessTrackerNavigator from '@/navigation/BusinessTracker/BusinessTrackerNavigator';
import SalesOrderNavigator from '@/navigation/transaction/SalesOrderNavigator';
import ReturnOrderNavigator from '@/navigation/transaction/RetrurnOrderNavigation';
import BrandCatalogNavigator from '@/navigation/transaction/BrandCatalogNavigator';
import CustomerNavigator from '@/navigation/customer/CustomerNavigator';
import LoyaltyNavigator from '@/navigation/customer/LoyaltyNavigator';
import CustomerRegisterNavigator from '@/navigation/customer/CustomerRegisterNavigator';
import BranchListNavigator from '@/navigation/setting/BranchListNavigator';
import BrandNavigator from '@/navigation/setting/BrandNavigator';
import ProfileNavigator from '@/navigation/ProfileNavigator';
import UserNavigator from '@/navigation/setting/UserNavigator';
import MatrixApprovalNavigator from '@/navigation/setting/MatrixApprovalNavigator';
import MarketBusinessTypeNavigator from '@/navigation/setting/MarketBusinessTypeNavigator';
import AccountGroupNavigator from '@/navigation/setting/AccountGroupNavigator';
import SalesTeamNavigator from '@/navigation/setting/SalesTeamNavigator';
import LoyaltyPointNavigator from '@/navigation/customer/LoyaltyPointNavigator';
import PlanogramNavigator from '@/navigation/setting/PlanogramNavigator';
import PromotionAccountNavigator from '@/navigation/setting/PromotionAccountNavigator';
import PricelistNavigator from '@/navigation/setting/PricelistNavigator';
import PromotionRulesNavigator from '@/navigation/setting/PromotionRulesNavigator';
import CustomerClusterNavigator from '@/navigation/setting/CustomerClusterNavigator';
import CustomerTypeNavigator from '@/navigation/setting/CustomerTypeNavigator';
import BudgetPocketNavigator from '@/navigation/setting/BudgetPocketNavigator';
import TargetSettingNavigator from '@/navigation/setting/TargetSettingNavigator';
import TaskNotificationNavigator from '@/navigation/TaskNotificationNavigator';
import CalendarNavigator from '@/navigation/CalendarNavigator';
import SalesActivityNavigator from '@/navigation/SalesActivityNavigator';
import CatalogNavigator from '@/navigation/CatalogNavigator';
import NewArrivalBestSellerNavigator from '@/navigation/setting/NewArrivalBestSellerNavigator';
import CMSNavigator from '@/navigation/setting/CMSNavigator';
import GuideBookNavigator from '@/navigation/setting/GuideBookNavigator';
import CoaTaxSettingNavigator from '@/navigation/setting/CoaTaxSettingNavigator';
import SkpExternalNavigator from '@/navigation/skp/SkpExternalNavigator';
import SkpInternalNavigator from '@/navigation/skp/SkpInternalNavigator';
import CreditLimitNavigator from '@/navigation/setting/CreditLimitNavigator';
import LPBNavigator from '@/navigation/LPB/LPBNavigator';
import InventoryNavigator from '@/navigation/inventory/InventoryNavigator';
import ForecastStockNavigator from '@/navigation/setting/ForecastStockNavigator';
import SubdistributorNavigator from '@/navigation/subdistributor/SubdistributorNavigator';
import RequestProductNavigator from '@/navigation/request-product/RequestProductNavigator';
import ProductStockNavigator from '@/navigation/request-product/ProductStockNavigator';
import PdfNavigator from '@/navigation/PdfNavigator';

import Colors from '@/global/colors';
import { isWeb, isMobileWeb, isAndroid } from '@global/screens';
import { VERSION } from '@constants';
import { updateAppVersion } from '@/store/auth/actions';

import packageJson from '../../package.json';

const Drawer = createDrawerNavigator();

const fetchVersionFromStorage = (isLoggedIn) => {
  const dispatch = useDispatch();
  const [versionStorage, setVersionStorage] = useState(null);
  const versionApp = isWeb ? packageJson.version : VERSION;
  const storage = isWeb ? localStorage : AsyncStorage;

  useEffect(() => {
    const fetchVersion = async () => {
      if (isLoggedIn) {
        const storedVersion = await storage.getItem('last_version');
        setVersionStorage(storedVersion);
      }
    };
    fetchVersion();
  }, [isLoggedIn]);

  useEffect(() => {
    const updateVersionIfNeeded = async () => {
      if (versionStorage && versionStorage !== versionApp) {
        await dispatch(updateAppVersion());
      }
    };
    updateVersionIfNeeded();
  }, [versionStorage]);
};

const RootNavigator = () => {
  const userAuth = useSelector((state) => state.auth.user);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  fetchVersionFromStorage(isLoggedIn);

  const initialScreen =
    (userAuth?.role?.code || userAuth?.role) == '3pl'
      ? 'ProfileNavigator'
      : 'HomeNavigator';
  return (
    <Drawer.Navigator
      useLegacyImplementation={false}
      initialRouteName={initialScreen}
      screenOptions={{
        headerShown: false,
        drawerType: isWeb ? 'permanent' : 'back',
        drawerStyle: isWeb
          ? {
              backgroundColor: Colors.blue1,
              border: 0,
              width: 240,
            }
          : {
              width: isMobileWeb || isAndroid ? '65%' : '70%',
            },
      }}
      // drawerContentOptions={{
      //   activeTintColor: Colors.blue0,
      //   activeBackgroundColor: '#EDEDEE',
      //   itemStyle: { marginVertical: 0, marginHorizontal: 0, borderRadius: 0 },
      // }}
      drawerContent={(props) => <DrawerMenu {...props} />}>
      <Drawer.Screen
        name="HomeNavigator"
        component={HomeNavigator}
        options={{
          drawerLabel: !isWeb ? 'Dashboard' : '',
        }}
      />
      <Drawer.Screen
        name="BusinessTrackerNavigator"
        component={BusinessTrackerNavigator}
        options={{
          drawerLabel: !isWeb ? 'Business Tracker' : '',
        }}
      />
      <Drawer.Screen
        name="SalesOrderNavigator"
        component={SalesOrderNavigator}
        options={{
          drawerLabel: !isWeb ? 'Sales Order' : '',
        }}
      />
      <Drawer.Screen
        name="ReturnOrderNavigator"
        component={ReturnOrderNavigator}
        options={{
          drawerLabel: !isWeb ? 'Return Order' : '',
        }}
      />
      <Drawer.Screen
        name="BrandCatalogNavigator"
        component={BrandCatalogNavigator}
        options={{
          drawerLabel: !isWeb ? 'Product Catalog' : '',
        }}
      />
      <Drawer.Screen
        name="CustomerNavigator"
        component={CustomerNavigator}
        options={{
          drawerLabel: !isWeb ? 'Customer' : '',
        }}
      />
      <Drawer.Screen
        name="CustomerRegisterNavigator"
        component={CustomerRegisterNavigator}
        options={{
          drawerLabel: !isWeb ? 'Customer' : '',
        }}
      />
      <Drawer.Screen
        name="LoyaltyNavigator"
        component={LoyaltyNavigator}
        options={{
          drawerLabel: !isWeb ? 'Customer' : '',
        }}
      />
      <Drawer.Screen
        name="LoyaltyPointNavigator"
        component={LoyaltyPointNavigator}
        options={{
          drawerLabel: !isWeb ? 'Loyalty Point Setup' : '',
        }}
      />
      <Drawer.Screen
        name="BranchListNavigator"
        component={BranchListNavigator}
        options={{
          drawerLabel: !isWeb ? 'Branch List' : '',
        }}
      />
      <Drawer.Screen
        name="BrandNavigator"
        component={BrandNavigator}
        options={{
          drawerLabel: !isWeb ? 'Brand' : '',
        }}
      />
      <Drawer.Screen
        name="PricelistNavigator"
        component={PricelistNavigator}
        options={{
          drawerLabel: !isWeb ? 'Pricelist' : '',
        }}
      />
      <Drawer.Screen
        name="ProfileNavigator"
        component={ProfileNavigator}
        options={{
          drawerLabel: !isWeb ? 'Setting' : '',
        }}
      />
      <Drawer.Screen
        name="UserNavigator"
        component={UserNavigator}
        options={{
          drawerLabel: !isWeb ? 'Users' : '',
        }}
      />
      <Drawer.Screen
        name="MatrixApprovalNavigator"
        component={MatrixApprovalNavigator}
        options={{
          drawerLabel: !isWeb ? 'Matrix Approval' : '',
        }}
      />
      <Drawer.Screen
        name="MarketBusinessTypeNavigator"
        component={MarketBusinessTypeNavigator}
        options={{
          drawerLabel: !isWeb ? 'Market & Business Type' : '',
        }}
      />
      <Drawer.Screen
        name="AccountGroupNavigator"
        component={AccountGroupNavigator}
        options={{
          drawerLabel: !isWeb ? 'Account Group' : '',
        }}
      />
      <Drawer.Screen
        name="SalesTeamNavigator"
        component={SalesTeamNavigator}
        options={{
          drawerLabel: !isWeb ? 'Sales Team' : '',
        }}
      />
      <Drawer.Screen
        name="PlanogramNavigator"
        component={PlanogramNavigator}
        options={{
          drawerLabel: !isWeb ? 'Planogram' : '',
        }}
      />
      <Drawer.Screen
        name="PromotionAccountNavigator"
        component={PromotionAccountNavigator}
        options={{
          drawerLabel: !isWeb ? 'Promotion Accounts' : '',
        }}
      />
      <Drawer.Screen
        name="TaskNotificationNavigator"
        component={TaskNotificationNavigator}
        options={{
          drawerLabel: !isWeb ? 'Notification' : '',
        }}
      />
      <Drawer.Screen
        name="CalendarNavigator"
        component={CalendarNavigator}
        options={{
          drawerLabel: !isWeb ? 'Calendar' : '',
        }}
      />
      <Drawer.Screen
        name="SalesActivityNavigator"
        component={SalesActivityNavigator}
        options={{
          drawerLabel: !isWeb ? 'Sales Activity' : '',
        }}
      />
      <Drawer.Screen
        name="PromotionRulesNavigator"
        component={PromotionRulesNavigator}
        options={{
          drawerLabel: !isWeb ? 'Promotion Rules' : '',
        }}
      />
      <Drawer.Screen
        name="CustomerClusterNavigator"
        component={CustomerClusterNavigator}
        options={{
          drawerLabel: !isWeb ? 'Customer Cluster' : '',
        }}
      />
      <Drawer.Screen
        name="CustomerTypeNavigator"
        component={CustomerTypeNavigator}
        options={{
          drawerLabel: !isWeb ? 'Customer Type' : '',
        }}
      />
      <Drawer.Screen
        name="BudgetPocketNavigator"
        component={BudgetPocketNavigator}
        options={{
          drawerLabel: !isWeb ? 'Budget Pocket' : '',
        }}
      />
      <Drawer.Screen
        name="TargetSettingNavigator"
        component={TargetSettingNavigator}
        options={{
          drawerLabel: !isWeb ? 'Target Setting' : '',
        }}
      />
      <Drawer.Screen
        name="CatalogNavigator"
        component={CatalogNavigator}
        options={{
          drawerLabel: !isWeb ? 'Catalog' : '',
        }}
      />
      <Drawer.Screen
        name="NewArrivalBestSellerNavigator"
        component={NewArrivalBestSellerNavigator}
        options={{
          drawerLabel: !isWeb ? 'Best Seller / New Arrival' : '',
        }}
      />
      <Drawer.Screen
        name="CMSNavigator"
        component={CMSNavigator}
        options={{
          drawerLabel: !isWeb ? 'Content Management System' : '',
        }}
      />
      <Drawer.Screen
        name="GuideBookNavigator"
        component={GuideBookNavigator}
        options={{
          drawerLabel: !isWeb ? 'Guide Book' : '',
        }}
      />
      <Drawer.Screen
        name="CoaTaxSettingNavigator"
        component={CoaTaxSettingNavigator}
        options={{
          drawerLabel: !isWeb ? 'COA Tax Setting' : '',
        }}
      />
      <Drawer.Screen
        name="SkpExternalNavigator"
        component={SkpExternalNavigator}
        options={{
          drawerLabel: !isWeb ? 'SKP External' : '',
        }}
      />
      <Drawer.Screen
        name="SkpInternalNavigator"
        component={SkpInternalNavigator}
        options={{
          drawerLabel: !isWeb ? 'SKP Internal' : '',
        }}
      />
      <Drawer.Screen
        name="CreditLimitNavigator"
        component={CreditLimitNavigator}
        options={{
          drawerLabel: !isWeb ? 'Credit Limit' : '',
        }}
      />
      <Drawer.Screen
        name="LPBNavigator"
        component={LPBNavigator}
        options={{
          drawerLabel: !isWeb ? 'GRN' : '',
        }}
      />
      <Drawer.Screen
        name="InventoryNavigator"
        component={InventoryNavigator}
        options={{
          drawerLabel: !isWeb ? 'Inventory' : '',
        }}
      />
      <Drawer.Screen
        name="ForecastStockNavigator"
        component={ForecastStockNavigator}
        options={{
          drawerLabel: !isWeb ? 'Forecast Stock' : '',
        }}
      />
      <Drawer.Screen
        name="SubdistributorNavigator"
        component={SubdistributorNavigator}
        options={{
          drawerLabel: !isWeb ? 'Subdistributor' : '',
        }}
      />
      <Drawer.Screen
        name="RequestProductNavigator"
        component={RequestProductNavigator}
        options={{
          drawerLabel: !isWeb ? 'Request Product' : '',
        }}
      />
      <Drawer.Screen
        name="ProductStockNavigator"
        component={ProductStockNavigator}
        options={{
          drawerLabel: !isWeb ? 'Product Stock' : '',
        }}
      />
      <Drawer.Screen
        name="PdfNavigator"
        component={PdfNavigator}
        options={{
          swipeEnabled: false,
          gestureEnabled: false,
          headerShown: false,
          drawerStyle: { display: 'none' },
        }}
      />
    </Drawer.Navigator>
  );
};

export default RootNavigator;
